import { render, staticRenderFns } from "./RegCompliance.vue?vue&type=template&id=954e7750"
import script from "./RegCompliance.vue?vue&type=script&lang=js"
export * from "./RegCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('954e7750')) {
      api.createRecord('954e7750', component.options)
    } else {
      api.reload('954e7750', component.options)
    }
    module.hot.accept("./RegCompliance.vue?vue&type=template&id=954e7750", function () {
      api.rerender('954e7750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/RegCompliance.vue"
export default component.exports